import { defineComponent } from "../../../common/runtime/defineComponent.svelte.ts";
import type { Props } from "./PromoCardV2.types.ts";
import shadowStyles from "./PromoCardV2.shadow.scss?inline";

defineComponent<Props>({
  tag: "oc-promo-card-v2",
  extendOptions: { useOcAutoAriaLabel: true },
  styles: () => import("./PromoCardV2.global.scss?inline"),
  props: {
    elevationLevel: { attribute: "elevation-level", reflect: true },
    inverted: { type: "Boolean", reflect: true },
  },
  html: `
<slot></slot>
<slot name="header-headline"></slot>
<slot name="header-overline"></slot>
<slot name="header-logo"></slot>
<slot name="action-signifier-header" aria-hidden="true"></slot>
<slot name="main"></slot>
<slot name="tags"></slot>
<slot name="footer-headline"></slot>
<slot name="footer-text"></slot>
<slot name="action-signifier-footer" aria-hidden="true"></slot>
<style>${shadowStyles}</style>
`,
});
